<template>
  <div>
    <ApproveLiquidation/>
  </div>
</template>

<script>
// @ is an alias to /src
import ApproveLiquidation from '@/components/ApproveLiquidation.vue'

export default {
  name: 'approve-liquidation-view',
  components: {
    ApproveLiquidation
  }
}
</script>
